import * as React from "react";
import styled from "styled-components";
import ContentSection from "../../components/about/content-section";
import ImageSection from "../../components/about/image-sectioin";
import { useEffect } from "react";
import AOS from "aos";

const StudyExperience = () => {
  useEffect(() => {
    // Initialize AOS with reduced animation settings
    AOS.init({
      once: true,
      mirror: false,
      duration: 600, // Reduced from 800
      offset: 100,
      easing: "ease-out"
    });

    // Refresh AOS on component mount
    AOS.refresh();
  }, []);

  return (
    <StudySection>
      <div data-aos="fade-in" data-aos-duration="600" data-aos-delay="100">
        <ImageSection
          imageSrc={"/assets/home/study-experience.png"}
          imageAlt={"Track Note"}
        />
      </div>
      <div data-aos="fade-in" data-aos-duration="600">
        <ContentSection
          imageSrc={"/assets/home/settings.png"}
          imageAlt={"Personalized Study Experience"}
          title={"Personalized Study Experience"}
          description={
            "Tailor your study sessions by focusing on specific topics, using spaced repetition for optimal recall, or simulating real exam conditions with timed tests."
          }
        />
      </div>
    </StudySection>
  );
};

const StudySection = styled.section`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 96px 32px 16px;
  max-width: 1456px;
  margin: 0 auto;
  width: 100%;
  gap: 20px;

  @media (max-width: 768px) {
    flex-direction: column;
    padding: 32px 16px;
    text-align: center;
  }
`;

export default StudyExperience;
